import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  INLegsAddOrderFormValues,
  INLegsTableReport,
  IUNLegsItem,
  NLegSendMode,
} from "../../Interfaces/nLegsInterfaces";
import { VolumeCalculationType } from "../../Interfaces/stepInterfaces";

interface INLegsSlice {
  addOrderFormValues: INLegsAddOrderFormValues | null;
  orderTableFetchDataFlag: boolean;
  tradeTableFetchDataFlag: boolean;
  editOrderRowValues: INLegsTableReport | null;
  editFlag: boolean;
}

const initialState: INLegsSlice = {
  addOrderFormValues: {
    uNLegsItems: Array.from({ length: 4 }, () => ({}) as IUNLegsItem),
    userIds: [],
    maxPairPosition: null,
    blockSizePercent: null,
    marginPercent: null,
    volumeType: VolumeCalculationType.FixedAmount,
    sendMode: NLegSendMode.Simultaneous,
  } as INLegsAddOrderFormValues,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
  editOrderRowValues: null,
  editFlag: false,
};

const NLegsSlice = createSlice({
  name: "nLegs",
  initialState,
  reducers: {
    setNLegsAddOrderFormValues: (
      store,
      action: PayloadAction<INLegsAddOrderFormValues>,
    ) => {
      store.addOrderFormValues = action.payload;
    },
    onNLegsOrderFormValuesChange: (
      store,
      action: PayloadAction<{
        name: string;
        value: any;
        name2?: string;
        value2?: any;
      }>,
    ) => {
      if (action.payload.name2)
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
          [action.payload.name2]: action.payload.value2,
        } as INLegsAddOrderFormValues;
      else
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
        } as INLegsAddOrderFormValues;
    },
    setNLegsOrderTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>,
    ) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setNLegsTradeTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>,
    ) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
    setNLegsEditRowValues: (
      store,
      action: PayloadAction<INLegsTableReport | null>,
    ) => {
      store.editOrderRowValues = action.payload;
    },
    setNLegsEditFlag: (store, action: PayloadAction<boolean>) => {
      store.editFlag = action.payload;
    },
  },
});

export const {
  setNLegsAddOrderFormValues,
  setNLegsOrderTableFetchDataFlag,
  setNLegsTradeTableFetchDataFlag,
  onNLegsOrderFormValuesChange,
  setNLegsEditRowValues,
  setNLegsEditFlag,
} = NLegsSlice.actions;
export default NLegsSlice.reducer;
